module.exports = __webpack_public_path__ + "7cea34de1cfaad30b625c9a06abec24b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/goto.svg
// module id = 754
// module chunks = 0